import React from "react";

import Helmet from "react-helmet";

import favicon from "../images/favicon.ico";
import Footer from "./footer";
import Navbar from "./navbar";

const Layout = ({ children }) => (
  <>
    <Helmet>
      <title>Julie Sidley CPA</title>
      <meta charSet="utf-8" />
      <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
    </Helmet>
    <section className="hero is-fullheight is-default is-bold">
      <Navbar />
      <main>
        <section className="section">{children}</section>
      </main>
      <Footer />
    </section>
  </>
);

export default Layout;
